import {orderCategoryPaths} from './orderDetailWindow'
export const orderRowDetailEvent='landiyun-order-row-detail'
const typeNames=['','电子版订单','纸质版订单','面料订单','饰品订单','量体订单','来图制版订单','量体定制订单','成衣定制订单','成衣现货订单','辅料订单','成衣预售订单','课程订单']
export function detailRow(row:any,path:string){
 if(!row || !/^\/orders\//.test(path) || path==='/orders/all')return null
 const drawing=typeof row.requestNumber==='string' && ['SUBMITTED','QUOTED','WITHDRAWN'].includes(row.status)
 const id=Number(drawing?row.detailId:row.orderDetailId ?? row.detailId ?? row.id)
 const inferred=orderCategoryPaths.findIndex(name=>name && path==='/orders/'+name)
 const type=drawing?6:Number(row.orderType || (inferred>0?inferred:0))
 if(!Number.isSafeInteger(id) || id<=0 || !(Number(row.orderId)>0) || !orderCategoryPaths[type] || !String(row.orderNumber || '').trim())return null
 return {...row,id,orderType:type,category:row.category || typeNames[type]}
}
export function openOrderRowDetails(row:any,rows:any[],route:{path:string;query?:any},event?:MouseEvent){
 if(route.query?.orderDetailEmbed==='1' || event?.defaultPrevented)return false
 const target=event?.target as Element|null
 if(target && typeof target.closest==='function' && target.closest('button,a,input,textarea,select,img,svg,[contenteditable="true"],[role="button"],[role="link"],[role="checkbox"],[role="combobox"],.ant-image,.admin-action-content,.row-action-overflow,.pointer'))return false
 const selected=detailRow(row,route.path);if(!selected)return false
 const family=rows.map(item=>detailRow(item,route.path)).filter(Boolean)
 window.dispatchEvent(new CustomEvent(orderRowDetailEvent,{detail:{order:selected,rows:family,sourceRows:rows,path:route.path}}));return true
}
